module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCI+PGRlZnM+PHN0eWxlLz48L2RlZnM+PHBhdGggZD0iTTUxMi4zIDYzLjRjLTI0NS44IDAtNDQ3IDIwMS4xLTQ0NyA0NDdzMjAxLjEgNDQ3IDQ0NyA0NDcgNDQ3LTIwMS4xIDQ0Ny00NDctMjAxLjEtNDQ3LTQ0Ny00NDd6bTAgODA0LjZjLTE5Ni43IDAtMzU3LjYtMTYwLjktMzU3LjYtMzU3LjZzMTYwLjktMzU3LjYgMzU3LjYtMzU3LjYgMzU3LjYgMTYwLjkgMzU3LjYgMzU3LjZTNzA5IDg2OCA1MTIuMyA4Njh6Ii8+PHBhdGggZD0iTTUzNC43IDI4Ni45aC02Ny4xdjI2OC4ybDIzMi41IDE0My4xIDM1LjctNTguMi0yMDEuMS0xMjAuNnoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/task.svg
// module id = EK3d
// module chunks = 72